var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3922_82339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8008 19.0742C16.8008 19.1836 16.7656 19.293 16.6562 19.3633L12.3633 23.6914L14.2539 25.582C14.4375 25.7656 14.5078 25.9453 14.5078 26.1641C14.5078 26.3828 14.4336 26.6016 14.2539 26.7461C14.0703 26.9297 13.8906 27 13.6719 27H7.85547C7.63672 27 7.41797 26.9258 7.27344 26.7461C7.08984 26.5625 7.01953 26.3828 7.01953 26.1641V20.3438C7.01953 20.125 7.09375 19.9063 7.27344 19.7617C7.45703 19.5781 7.63672 19.5078 7.85547 19.5078C8.07422 19.5078 8.29297 19.582 8.4375 19.7617L10.3281 21.6523L14.6562 17.3281C14.7305 17.2539 14.8398 17.1836 14.9453 17.1836C15.0508 17.1836 15.1641 17.2188 15.2344 17.3281L16.7266 18.8203C16.7617 18.8555 16.8008 18.9648 16.8008 19.0742ZM26.9805 7.83594V13.6523C26.9805 13.8711 26.9062 14.0898 26.7266 14.2344C26.543 14.418 26.3633 14.4883 26.1445 14.4883C25.9258 14.4883 25.707 14.4141 25.5625 14.2344L23.6719 12.3438L19.3828 16.7109C19.3086 16.7852 19.1992 16.8555 19.0938 16.8555C18.9844 16.8555 18.875 16.8203 18.8047 16.7109L17.3125 15.2188C17.2383 15.1445 17.168 15.0352 17.168 14.9297C17.168 14.8203 17.2031 14.7109 17.3125 14.6406L21.6367 10.3086L19.7461 8.41797C19.5625 8.23438 19.4922 8.05469 19.4922 7.83594C19.4922 7.61719 19.5664 7.39844 19.7461 7.25391C19.9297 7.07031 20.1094 7 20.3281 7H26.1445C26.3633 7 26.582 7.07422 26.7266 7.25391C26.9102 7.39844 26.9805 7.61719 26.9805 7.83594Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3922_82339",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3922_82339"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3922_82339",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.e67cd34739ec8c478c6e90bbc92c3c5f.svg";
export { ForwardRef as ReactComponent };